import type { ITelemetryItem } from '@microsoft/applicationinsights-web'
import { APP_INSIGHTS_ROLE_NAME } from '~~/shared/appInsightsRoleName'

// Tag browser telemetry with the same cloud_RoleName as the server. AB#63632
export const tagRoleName = (envelope: ITelemetryItem) => {
  envelope.tags = envelope.tags ?? {}
  envelope.tags['ai.cloud.role'] = APP_INSIGHTS_ROLE_NAME
  return true
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$appInsights?.addTelemetryInitializer(tagRoleName)
})
